// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCOQlWESgGJUjcajUS6uF_dL-SUTl06Kf0",
    authDomain: "questionapp-121fd.firebaseapp.com",
    projectId: "questionapp-121fd",
    storageBucket: "questionapp-121fd.appspot.com",
    messagingSenderId: "633067048256",
    appId: "1:633067048256:web:7ca6fe000f4d07ac2afea5"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
